/**
 * Tento soubor sdružuje všechny importy funkcionality kompatibilní se strict buildem z původní části aplikace.
 * Typy se importují přes modulu types/multiweb.
 */

export { DataConverter } from "../../../../../../Global/Base/Converters/DataConverter";
export { AttrValue } from "../../../../../../Global/Base/DataTypes/AttrValue";
export { BigNumberProxy } from "../../../../../../Global/Base/DataTypes/BigNumber";
export { UUID } from "../../../../../../Global/Base/IDs/UUID";
export { DateUtils } from "../../../../../../Global/Base/Utils/DateUtils";
export { EnumUtils } from "../../../../../../Global/Base/Utils/EnumUtils";
export { FlagUtils } from "../../../../../../Global/Base/Utils/FlagUtils";
export { NumberUtils } from "../../../../../../Global/Base/Utils/NumberUtils";
export { StringUtils } from "../../../../../../Global/Base/Utils/StringUtils";
export { UrlUtils } from "../../../../../../Global/Base/Utils/UrlUtils";
export { Globalization } from "../../../../../../Global/Dom/Globalization";
export { LocalizationUtils } from "../../../../../../OW.Remoting/Remoting/LocalizationUtils";
export { getExtendedPropertiesFromElement } from "UI/utils";
